import AddIcon from '@mui/icons-material/Add';
import CloseIcon from '@mui/icons-material/Close';
import EditIcon from '@mui/icons-material/Edit';
import {
  Box,
  Button,
  Card,
  CardHeader,
  Chip,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  LinearProgress,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  ToggleButton,
  ToggleButtonGroup,
  Tooltip
} from '@mui/material';
import React, { useEffect, useMemo } from 'react';
import { useDispatch } from 'react-redux';
import { getServiceRejectionReasons } from 'src/store/slices/dynamicCatalogSlice';
import { AddOrUpdateServiceRejectionReason } from 'src/store/slices/dynamicCatalogSlice';
import {
  ORANGE,
  darkButtonSx,
  dialogPaperProps,
  inputSx,
  lightButtonSx,
  statusChipSx,
  useDynamicStyles
} from 'src/components/dynamicCatalogStyles';
import DynamicListToolbar, { filterDynamicRows } from 'src/components/DynamicListToolbar';

function ServiceRefundDynamic() {
  const classes = useDynamicStyles();
  const dispatch = useDispatch();

  const [ServiceRejectionReasons, setServiceRejectionReasons] = React.useState(null);
  const [updatePopUp, setUpdatePopUp] = React.useState(false);
  const [loading, setLoading] = React.useState(false);
  const [saving, setSaving] = React.useState(false);
  const [isServiceRejectionReasonUpdate, setIsServiceRejectionReasonUpdate] = React.useState(false);
  const [addOrUpdateServiceRejectionReasonId, setaddOrUpdateServiceRejectionReasonId] = React.useState("");
  const [addOrUpdateServiceRejectionReason, setaddOrUpdateServiceRejectionReason] = React.useState("");
  const [addOrUpdateServiceRejectionReasonActive, setaddOrUpdateServiceRejectionReasonActive] = React.useState(true);
  const [selectedServiceRejectionReason, setSelectedServiceRejectionReason] = React.useState([]);
  const [searchText, setSearchText] = React.useState('');
  const [statusFilter, setStatusFilter] = React.useState('all');

  useEffect(() => {
    setLoading(true);
    dispatch(getServiceRejectionReasons()).then(response => {
      if (response.payload?.length > 0) {
        setServiceRejectionReasons(response.payload);
      }
      setLoading(false);
    })
  }, [dispatch]);

  function updateServiceRejectionReasonClick(row) {
    setIsServiceRejectionReasonUpdate(true);
    setaddOrUpdateServiceRejectionReasonId(row.DEGISIM_RED_NEDENI);
    setaddOrUpdateServiceRejectionReason(row.ACIKLAMA);
    setaddOrUpdateServiceRejectionReasonActive(row.AKTIF);
    setSelectedServiceRejectionReason(row);
    setUpdatePopUp(true);
  }
  const addServiceRejectionReasonClick = () => {
    setIsServiceRejectionReasonUpdate(false);
    clearAddOrUpdateServiceReason();
    setUpdatePopUp(true);
  }
  function clearAddOrUpdateServiceReason() {
    setaddOrUpdateServiceRejectionReasonId("");
    setaddOrUpdateServiceRejectionReason("");
    setaddOrUpdateServiceRejectionReasonActive(true);
  }
  function closePopUp() {
    if (saving) return;
    setUpdatePopUp(false);
  }
  function addOrUpdateServiceRejectionReasonClick() {
    var reasonId = addOrUpdateServiceRejectionReasonId.toString();
    var Reason = addOrUpdateServiceRejectionReason.toString();
    var Active = addOrUpdateServiceRejectionReasonActive;

    let Reasondata = {
      ReasonId: reasonId,
      Reason: Reason,
      Active: Active
    };

    setSaving(true);
    dispatch(AddOrUpdateServiceRejectionReason(Reasondata)).then(() => {
      setSaving(false);
      setUpdatePopUp(false);
      clearAddOrUpdateServiceReason();
      setLoading(true);
      dispatch(getServiceRejectionReasons()).then(response => {
        if (response.payload?.length > 0) {
          setServiceRejectionReasons(response.payload);
        }
        setLoading(false);
      })
    })
  }

  const rowCount = ServiceRejectionReasons?.length || 0;
  const activeCount = (ServiceRejectionReasons || []).filter((r) => r.AKTIF === true).length;
  const filteredRows = useMemo(() => filterDynamicRows(ServiceRejectionReasons, {
    searchText,
    statusFilter,
    searchFields: ['ACIKLAMA'],
    isActive: (r) => r.AKTIF === true
  }), [ServiceRejectionReasons, searchText, statusFilter]);
  const reasonEmpty = !addOrUpdateServiceRejectionReason?.toString().trim();

  return (
    <>
      <Card className={classes.card}>
        <CardHeader
          className={classes.cardHeader}
          title="Servis Red Nedenleri"
          subheader={loading ? 'Yükleniyor…' : `${rowCount} kayıt · ${activeCount} aktif · ${rowCount - activeCount} pasif`}
          action={
            <Button
              startIcon={<AddIcon />}
              sx={darkButtonSx}
              onClick={addServiceRejectionReasonClick}
            >
              Yeni Red Nedeni
            </Button>
          }
        />
        {loading && <LinearProgress sx={{ height: 2, '& .MuiLinearProgress-bar': { backgroundColor: ORANGE }, backgroundColor: '#ffe0b2' }} />}
        <DynamicListToolbar
          searchText={searchText}
          onSearchChange={setSearchText}
          placeholder="Red nedeni ara"
          statusFilter={statusFilter}
          onStatusFilterChange={setStatusFilter}
          shownCount={filteredRows.length}
        />
        <TableContainer sx={{ maxHeight: 520 }}>
          <Table stickyHeader size="small" className={classes.table}>
            <TableHead>
              <TableRow>
                <TableCell align="left">Red Nedeni</TableCell>
                <TableCell align="center" sx={{ width: 120 }}>Durum</TableCell>
                <TableCell align="center" sx={{ width: 90 }}>İşlem</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {filteredRows.map((row) => (
                <TableRow key={row.DEGISIM_RED_NEDENI}>
                  <TableCell align="left">{row.ACIKLAMA}</TableCell>
                  <TableCell align="center">
                    <Chip size="small" label={row.AKTIF === true ? 'Aktif' : 'Pasif'} sx={statusChipSx(row.AKTIF === true)} />
                  </TableCell>
                  <TableCell align="center">
                    <Tooltip title="Düzenle">
                      <IconButton size="small" onClick={() => updateServiceRejectionReasonClick(row)}>
                        <EditIcon sx={{ fontSize: 18, color: ORANGE }} />
                      </IconButton>
                    </Tooltip>
                  </TableCell>
                </TableRow>
              ))}
              {!loading && filteredRows.length === 0 && (
                <TableRow>
                  <TableCell colSpan={3} className={classes.emptyState}>
                    {rowCount === 0 ? 'Kayıtlı red nedeni bulunamadı.' : 'Aramaya uygun kayıt bulunamadı.'}
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </Card>

      <Dialog
        open={updatePopUp}
        onClose={closePopUp}
        fullWidth
        maxWidth="sm"
        PaperProps={dialogPaperProps}
      >
        <DialogTitle className={classes.dialogTitle}>
          {isServiceRejectionReasonUpdate ? 'Red Nedeni Düzenle' : 'Yeni Red Nedeni'}
          <IconButton size="small" onClick={closePopUp} disabled={saving}>
            <CloseIcon fontSize="small" />
          </IconButton>
        </DialogTitle>
        <DialogContent sx={{ pt: '16px !important', opacity: saving ? 0.6 : 1, pointerEvents: saving ? 'none' : 'auto', transition: 'opacity 0.2s' }}>
          <TextField
            label="Red Nedeni"
            fullWidth
            multiline
            minRows={2}
            maxRows={4}
            size="small"
            sx={inputSx}
            onChange={(e) => setaddOrUpdateServiceRejectionReason(e.target.value)}
            value={addOrUpdateServiceRejectionReason}
          />
          <Box className={classes.dialogSection} sx={{ mt: 2 }}>
            <div className={classes.sectionLabel}>Durum</div>
            <ToggleButtonGroup
              exclusive
              size="small"
              className={classes.toggleGroup}
              value={addOrUpdateServiceRejectionReasonActive}
              onChange={(e, v) => v !== null && setaddOrUpdateServiceRejectionReasonActive(v)}
            >
              <ToggleButton value={true}>Aktif</ToggleButton>
              <ToggleButton value={false}>Pasif</ToggleButton>
            </ToggleButtonGroup>
          </Box>
        </DialogContent>
        <DialogActions sx={{ px: 3, pb: 2.5 }}>
          <Button sx={lightButtonSx} onClick={closePopUp} disabled={saving}>Vazgeç</Button>
          <Button
            sx={{ ...darkButtonSx, minWidth: 110 }}
            onClick={addOrUpdateServiceRejectionReasonClick}
            disabled={saving || reasonEmpty}
            startIcon={saving ? <CircularProgress size={14} sx={{ color: ORANGE }} /> : null}
          >
            {isServiceRejectionReasonUpdate ? 'Güncelle' : 'Ekle'}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}

export default ServiceRefundDynamic;
